import { useState } from "react";
import { Button } from "@chakra-ui/react";

/**
 * A button that shows a spinner and is disabled when the button is clicked. If onClick returns a promise, then the spinner will show until the promise resolves.
 */
export default function SlowButton({ children, onClick, ...props }) {
  const [isLoading, setIsLoading] = useState(false);
  const handleClick = () => {
    if (isLoading) return; // disabled -- should not be clicked
    setIsLoading(true);
    let p = onClick();
    if (p && p.finally) {
      p.finally(() => setIsLoading(false));
    } else {
      setIsLoading(false);
    }
  };
  return (
    <Button {...props} onClick={handleClick} isLoading={isLoading}>
      {children}
    </Button>
  );
}
